export var cilCaretRight = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M148.092,496h-36.45V16.333h34.547L416,256.286Zm-4.45-439.108v400.15L367.929,256.358Z' class='ci-primary'/>"];
